import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Locations', href: '/#locations' },
  { label: 'Download App', href: '#download' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || menuOpen ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center">
          <img
            src="https://i.ibb.co/G4Wc9Knk/sweetplate-logo.png"
            alt="Sweet Plate"
            className="h-9 w-auto object-contain"
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-[#009E81]' : 'text-white hover:text-[#a8f0e2]'
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://merchant.sweetplate.org/"
            target="_blank"
            rel="noopener noreferrer"
            className={`text-sm font-semibold px-5 py-2 rounded-full transition-colors cursor-pointer whitespace-nowrap ${
              scrolled
                ? 'bg-[#009E81] text-white hover:bg-[#008570]'
                : 'bg-white/20 text-white border border-white/50 hover:bg-white/30 backdrop-blur-sm'
            }`}
          >
            Become a Vendor
          </a>
        </nav>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-xl transition-colors cursor-pointer ${
            scrolled || menuOpen ? 'bg-gray-100 hover:bg-gray-200' : 'bg-white/20 hover:bg-white/30'
          }`}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-xl ${scrolled || menuOpen ? 'text-gray-700' : 'text-white'}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 pt-3 pb-5 flex flex-col gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-sm font-semibold text-gray-700 hover:text-[#009E81] hover:bg-gray-50 transition-colors px-4 py-3 rounded-xl cursor-pointer block"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://merchant.sweetplate.org/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
            className="mt-2 bg-[#009E81] text-white text-sm font-bold px-5 py-3 rounded-xl hover:bg-[#008570] transition-colors cursor-pointer text-center block whitespace-nowrap"
          >
            Become a Vendor
          </a>
        </div>
      )}
    </header>
  );
}
